var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SfButton',_vm._g({staticClass:"sf-arrow",attrs:{"type":"button"}},_vm.$listeners),[_vm._t("default",function(){return [_c('SfIcon',{staticClass:"sf-arrow__icon",attrs:{"size":"1.25rem","icon":"chevron_left","aria-hidden":"true"}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }